"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Option = void 0;
const icons_1 = require("client/components/icons");
const react_1 = require("react");
const React = require("react");
require("./option.less");
class Option extends react_1.Component {
    constructor() {
        super(...arguments);
        this.handleCloseClick = (item) => (event) => {
            this.props.onCloseClick && this.props.onCloseClick(item);
        };
    }
    render() {
        const { item } = this.props;
        return (React.createElement("div", { className: "option" },
            React.createElement("div", { className: "center option__value" },
                React.createElement("div", { className: "label" }, item.tokenLabel || item.label)),
            React.createElement("div", { className: "option__bar" }),
            React.createElement("div", { className: "center option__delete", onClick: this.handleCloseClick(item) },
                React.createElement(icons_1.CloseIcon, { fill: "rgba(255, 255, 255, 0.5)" }))));
    }
}
exports.Option = Option;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/inventory/modules/inventory-detail/components/edit-inventory/diagnosis-select/option/option.tsx
// module id = 3482
// module chunks = 0